var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useState } from "react";
import { classNames } from "../Util";
import useLocationHash from "../Hook/UseLocationHash/UseLocationHash";
var TabControl = function (_a) {
    var _b = _a.wrapperClassname, wrapperClassname = _b === void 0 ? "py-6" : _b, tabs = _a.tabs, selectTabText = _a.selectTabText, _c = _a.disableHash, disableHash = _c === void 0 ? false : _c;
    var _d = useState(tabs.findIndex(function (t) { return t.current; })), currentTab = _d[0], setCurrentTab = _d[1];
    var _e = useState(tabs), allTabs = _e[0], setAllTabs = _e[1];
    var hash = useLocationHash();
    var id = useId();
    var handleSwitchCurrentTab = function (index) {
        setAllTabs(allTabs.map(function (t, i) {
            var current = i === index;
            t.current = current;
            if (current && t.onOpen && i !== currentTab) {
                t.onOpen();
            }
            return t;
        }));
        setCurrentTab(index);
    };
    var switchHash = function (index) {
        if (disableHash) {
            handleSwitchCurrentTab(index);
            return;
        }
        window.location.hash = allTabs[index].hash || "";
    };
    useEffect(function () {
        var index = hash === ""
            ? allTabs.findIndex(function (t) { return t.defaultTab; })
            : allTabs.findIndex(function (t) { return t.hash === window.location.hash.replace("#", ''); });
        if (index > -1) {
            handleSwitchCurrentTab(index);
        }
    }, [hash]);
    return (_jsxs("div", __assign({ className: wrapperClassname }, { children: [_jsxs("div", __assign({ className: "lg:hidden" }, { children: [_jsx("label", __assign({ htmlFor: id, className: "sr-only" }, { children: selectTabText })), _jsx("select", __assign({ id: id, name: "selected-tab", className: "mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm", value: currentTab, onChange: function (e) { return switchHash(parseInt(e.target.value)); } }, { children: allTabs.map(function (tab, index) { return (_jsx("option", __assign({ value: index }, { children: tab.name }), index)); }) }))] })), _jsx("div", __assign({ className: "hidden lg:block" }, { children: _jsx("div", __assign({ className: "border-b border-gray-200" }, { children: _jsx("nav", __assign({ className: "-mb-px flex space-x-8" }, { children: allTabs.map(function (tab, index) { return (_jsxs("button", __assign({ onClick: function (e) {
                                e.preventDefault();
                                switchHash(index);
                            }, className: classNames(tab.current
                                ? "border-blue-500 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300", "group inline-flex items-center text-left py-4 px-1 border-b-2 font-medium text-sm"), "aria-current": tab.current ? "page" : undefined }, { children: [_jsx(tab.icon, { className: classNames(tab.current ? "text-blue-500" : "text-gray-400 group-hover:text-gray-500", "-ml-0.5 mr-2 h-5 w-5 shrink-0"), "aria-hidden": "true" }), _jsx("span", { children: tab.name })] }), tab.name)); }) })) })) })), _jsx("div", __assign({ className: "mt-10" }, { children: tabs[currentTab].content }))] })));
};
export default TabControl;
